import type {  VerificationDTO, FinalizeVerifyDTO,FinalizeLoginDTO, InitLoginDTO, InitRegistrationDTO, LoginRequest, LoginResult, LoginDTO, RecoveryVerificationDTO } from "@/types/dtos.types";
import type { TwoFactorMethod } from "@/types/authState.types";

export abstract class AuthService {
  /* ─── Login / Logout ─── */
  abstract login(data: LoginDTO): Promise<LoginResult>;
  abstract logout(): Promise<void>;
  abstract initLogin(data: { username: string,ke1:string }): Promise<InitLoginDTO>;
  abstract finalizeLogin(data: {sessionId: string, ke3: string}): Promise<FinalizeLoginDTO>

  /* ─── Registration wizard ─── */
  abstract confirmEmail(data: { code: string }): Promise<void>;
  abstract sendEmailCode(): Promise<VerificationDTO>;
  abstract resendEmailCode(): Promise<VerificationDTO>;
  abstract beginRegistration(data: { username: string; otp: string }): Promise<{ registrationToken: string }>;
  abstract setPassword(data: { username: string; password: string }): Promise<void>;
  abstract confirmPhone(data: { code: string }): Promise<void>;
  abstract resendPhoneCode(): Promise<VerificationDTO>;
  abstract forgotPassword(data: {emailAddress: string}): Promise<void>;
  abstract sendPhoneCode(): Promise<VerificationDTO>;
  abstract initRegistration(data: {  username: string,registrationRequest:string }): Promise<InitRegistrationDTO>;
  abstract finalizeRegistration(data: {sessionId: string, registrationRecord: string}): Promise<void>;
  abstract verifyRecoveryOtp(data: {emailAddress: string, code: string}): Promise<RecoveryVerificationDTO>;
  abstract sendRecoveryTwoFactor(data: {recoveryToken: string}): Promise<VerificationDTO>;
  abstract verifyRecoveryTwoFactor(data: {recoveryToken: string, code: string}): Promise<void>;

  /* ─── Two-Factor after password login ─── */
  abstract selectTwoFactorMethod(data: { method: "sms" | "email", twoFactorToken: string }): Promise<VerificationDTO>;
  abstract verifyTwoFactorCode(data: { code: string, twoFactorToken: string, method: TwoFactorMethod }): Promise<FinalizeVerifyDTO>;
   abstract resendTwoFactorCode(data: { method: "sms" | "email", twoFactorToken: string }): Promise<VerificationDTO>;
}
